/* eslint-disable import/no-cycle */
import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as URLS from 'src/constants/Api'
import { RootState } from 'src/redux'
import client, { FlatsyApiError } from 'src/utils/client'
import { Applicant } from '@flatsy/types/Applications/Applicant'
import { BasicApplicantInformation } from './Type'

export const saveApplicant = createAsyncThunk<
  Applicant,
  Applicant,
  {
    rejectValue: FlatsyApiError
  }
>(
  'application/saveApplicant',
  async (body, { rejectWithValue }) => {
    return client<Applicant>(URLS.UPDATE_APPLICANT(body.id, body.applicant_id), {
      body,
      method: body.id ? 'PATCH' : 'POST',
    }).catch((err) => {
      return rejectWithValue(err)
    })
  },
  {
    condition: (_, { getState }) => {
      const { saveStatus } = (getState as () => RootState)().applicants
      if (saveStatus === FetchStatus.LOADING) {
        return false
      }
    },
  }
)

export const saveApplicantInApplication = createAsyncThunk<
  Applicant,
  BasicApplicantInformation,
  {
    rejectValue: FlatsyApiError
  }
>('application/saveApplicantInApplication', async (body, { rejectWithValue }) => {
  return client<Applicant, BasicApplicantInformation>(
    URLS.UPDATE_APPLICANT(body.id, body.applicant_id),
    {
      body,
      method: body.id ? 'PATCH' : 'POST',
    }
  ).catch((err) => {
    return rejectWithValue(err)
  })
})

export const getApplicants = createAsyncThunk<
  Applicant[],
  string,
  {
    rejectValue: FlatsyApiError
  }
>(
  'application/getApplicants',
  async (applicationId, { rejectWithValue }) => {
    return client<Applicant[]>(URLS.APPLICANT(applicationId)).catch((err) => {
      return rejectWithValue(err)
    })
  },
  {
    condition: (_, { getState }) => {
      const status: FetchStatus = (getState as () => RootState)().applicants.fetchStatus
      if (FetchStatus.LOADING === status) {
        // Already fetched or in progress, don't need to re-fetch
        return false
      }
    },
  }
)
